<template>
  <v-container grid-list-md text-xs-left v-if="user !== null && pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{user.surname !== null ? user.surname : ''}} {{user.first_name !== null ? user.first_name : ''}} {{user.patronymic !== null ? user.patronymic : ''}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs8>

        <v-layout class="elevation-1 white mb-4 pa-3">
          <v-flex xs12>
            <v-avatar
                :tile="false"
                :size="72"
                color="grey lighten-4"
                class="ma-3 float-left"
            >
              <img :src="user.photo.url_resized" alt="avatar">
            </v-avatar>
            <div>
              <p class="title mt-4">{{user.surname}} {{user.first_name}} {{user.patronymic}}</p>
              <p class="body-2 mt-3" v-if="user.user_group !== null">{{user.user_group.title}}</p>
            </div>
          </v-flex>
        </v-layout>

        <v-layout class="elevation-1 white mb-4 pa-3">
          <v-flex xs12>
            <div v-if="typeof user.branch !== 'undefined' && user.branch !== null">
              <div v-if="user.branch.title !== ''">
                <span class="title">Филиал: </span>
                <span class="title font-weight-thin">{{user.branch === null ? 'Все филиалы' : user.branch.title}}</span>
              </div>
            </div>
            <div>
              <span class="title float-left">Телефон: </span>
              <v-text-field
                  class="user-self-info-masked-input"
                  :value="user.phone"
                  mask="+7 (###) ###-##-##"
                  disabled
              ></v-text-field>
            </div>
            <div v-if="user.email !== '' && user.email !== null && typeof user.email !== 'undefined'">
              <span class="title">E-mail: </span>
              <span class="title font-weight-thin">{{user.email}}</span>
            </div>
            <div v-if="user.email === '' || user.email === null || typeof user.email === 'undefined'">
              <span class="title">E-mail: </span>
              <span class="title font-weight-thin font-italic">не указан</span>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="pointListTreeData !== null && pointListTreeData.length > 0">
          <p class="title">Торговые точки</p>
          <v-layout row class="elevation-1 white mb-4 pa-3">
            <v-flex xs12 lg12 md12>
              <tree
                  :options="{
                          checkbox: true
                        }"
                  :data="pointListTreeData"
                  class="tree--small tree-single-page"
              />
            </v-flex>
          </v-layout>
        </div>

      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editUser(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить пользователя?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteUserConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Пользователи', link: '/users/active'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pointListTreeData: [],
        pageDataReady: {
          isReady: false,
          user: false
        },
        deleteDialog: false
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getUserSingle', {id: this.$route.params.id})
    },
    computed: {
      user () {
        return this.$store.getters.userSingle
      }
    },
    methods: {
      editUser (id) {
        this.$router.push('/users/edit/' + id)
      },
      deleteUserConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteUser', {id: this.id})
        this.$router.push('/users/active/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.user) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      pointTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeData(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      }
    },
    watch: {
      user (val) {
        let name = this.user.surname !== null ? this.user.surname + ' ' : ''
        name += this.user.first_name !== null ? this.user.first_name + ' ' : ''
        name += this.user.patronymic !== null ? this.user.patronymic + ' ' : ''
        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Пользователи', link: '/users/active'}
        ]
        this.breadcrumbs.push({name: name})
        this.$store.commit('setPageTitle', name)
        this.pageDataReady.user = true
        this.pageDataStatus()

        this.id = this.user.id
        if (this.user.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        if (typeof this.user.point_folder_tree !== 'undefined') {
          this.pointListTreeData = this.pointTreeData(this.user.point_folder_tree)
        }

        this.actions.canUpdate = this.user.can_update
        this.actions.canRemove = this.user.can_remove
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserSingle.vue